/* Page loader - brutalist gothic intro
   - Fake progress that completes when window loads (or after min time)
   - Optional once-per-session via data-once
   - Wipes up when done
*/
(function () {
  var ldr = document.querySelector('[data-page-loader]');
  if (!ldr) return;

  var once = ldr.getAttribute('data-once') === 'true';
  var STORAGE_KEY = 'ldr_seen';

  // Skip if already seen this session
  if (once) {
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') {
        ldr.parentNode && ldr.parentNode.removeChild(ldr);
        return;
      }
    } catch (e) {}
  }

  document.body.classList.add('ldr-active');

  var fill = ldr.querySelector('[data-ldr-fill]');
  var pctEl = ldr.querySelector('[data-ldr-pct]');
  var minMs = parseInt(ldr.getAttribute('data-min'), 10) || 900;
  var start = Date.now();
  var pct = 0;
  var loaded = false;

  function setPct(v) {
    pct = Math.min(100, v);
    if (fill) fill.style.width = pct + '%';
    if (pctEl) pctEl.textContent = Math.round(pct) + '%';
  }

  // Fake incremental progress toward 90% while assets load
  var creep = window.setInterval(function () {
    if (pct < 90) {
      setPct(pct + Math.random() * 8);
    }
  }, 140);

  function finish() {
    window.clearInterval(creep);
    setPct(100);
    if (once) {
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }
    window.setTimeout(function () {
      ldr.classList.add('is-done');
      document.body.classList.remove('ldr-active');
      window.setTimeout(function () {
        ldr.parentNode && ldr.parentNode.removeChild(ldr);
      }, 800);
    }, 220);
  }

  function tryFinish() {
    var elapsed = Date.now() - start;
    var wait = Math.max(0, minMs - elapsed);
    window.setTimeout(finish, wait);
  }

  if (document.readyState === 'complete') {
    loaded = true;
    tryFinish();
  } else {
    window.addEventListener('load', function () {
      loaded = true;
      tryFinish();
    });
    // Safety: never hang longer than 6s
    window.setTimeout(function () {
      if (!loaded) finish();
    }, 6000);
  }
})();